import { createAction } from "@reduxjs/toolkit";
import { PreAuthToken, Token } from "@repo/schema";

export const setCredentials = createAction<Token>("auth/setCredentials");
export const setPreAuthCredentials = createAction<PreAuthToken>("auth/setPreAuthCredentials");
export const clearCredentials = createAction("auth/clearCredentials");

/**
 * The relay refused a deploy because the organization is restricted.
 *
 * Flags reach the client in the token payload, so a member holding a session
 * minted before the flag was flipped still sees a live Deploy button. The 403
 * is the server telling us what the token no longer does; recording it here
 * re-gates the UI immediately instead of at the next refresh.
 *
 * Declared standalone, like the credential actions above, so a dispatcher does
 * not have to import the slice — and through it the organization API.
 */
export const organizationRestricted = createAction("auth/organizationRestricted");
